




























import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import requests from '@/helpers/requests'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
}


interface Campaign {
    name: string;
    id: string;
    campaignUid: string;
}


interface LoadData {
    totalCampaignCount: number;
    invalidIdCount: number;
    invalidCampaigns: Campaign[];
}


interface LoadResponse {
    data: LoadData;
    message: string;
    status: number;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SetupSuccessWareIntegration extends Vue {
    locationValid = false
    loadingInformation = false
    pulsemAccountId: number|null = null
    errorMessage: string|null = ''
    data: LoadData|null = null

    headers = [
        { text: 'Campaign UID', value: 'campaignUid' },
        { text: 'Name', value: 'name' },
        { text: 'API ID', value: 'id' }
    ]

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId
        }
    }

    async onLocationChange(locationValid: boolean) {
        this.errorMessage = null
        this.data = null
        if (locationValid) {
            this.loadingInformation = true
            try {
                const response = await requests.post('/support/technician-audit', {
                    pulsemAccountId: this.pulsemAccountId
                }) as LoadResponse
                this.data = response.data
                this.locationValid = locationValid
            } catch(e) {
                this.errorMessage = e.message
                this.locationValid = false
            }
            this.loadingInformation = false
        } else {
            this.locationValid = false
            this.loadingInformation = false
        }
    }

    onSubmit() {
        this.onLocationChange(this.locationValid)
    }
}
